<template>
	<div class="badge" :class="{ large }">
		<img v-if="image && imagePath" class="mr-3" :src="imagePath" alt="icon" />
		<span>{{ text }}</span>
	</div>
</template>

<script>
export default {
	name: 'Badge',

	data: () => ({
		imagePath: ''
	}),

	props: {
		text: {
			type: [String, Number],
			default: ''
		},

		large: {
			type: Boolean,
			default: false
		},

		// image name from ../assets/images/
		image: {
			type: String,
			default: ''
		}
	},

	async created() {
		this.imagePath = await this.importImage()
	},

	methods: {
		async importImage() {
			if (!this.image) return

			const getImagePath = () => import(`../assets/images/${this.image}`)
			const imagePath = await getImagePath()

			return imagePath?.default || ''
		}
	}
}
</script>

<style scoped lang="scss">
@import './src/assets/styles/variables';

.badge {
	display: flex;
	align-items: center;
	padding: 3px 6px;
	width: fit-content;
	font-size: 12px;
	line-height: 14px;
	background-color: $white;
	color: $dark-blue;
	border-radius: 10px;

	&.large {
		padding: 5px 8px;
		font-weight: 600;
		text-transform: uppercase;
	}
}
</style>
